// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__8_yf9","clinicsSelect":"TableHeading_clinicsSelect__xgl4E"};